module.exports = __webpack_public_path__ + "img/mdm-deploy-6.921f6c7e.jpg";